export default __webpack_public_path__ + "static/media/default.a806e17e.jpg";